import React = require('react');

interface IStatusBadge {
  status: string;
}

export enum PStatus {
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  RENEWING = 'renewing',
  UPCOMING = 'upcoming',
  EXPIRING = 'expiring',
  QUOTE = 'quote',
}

export const StatusBadge = ({ status }: IStatusBadge) => {
  let color = 'green';
  let statusDisplay = 'Active';

  switch (status) {
    case PStatus.EXPIRED:
      color = 'grey';
      statusDisplay = 'Expired'
      break;
    case PStatus.CANCELLED:
      color = 'grey';
      statusDisplay = 'Cancelled'
      break;
    case PStatus.RENEWING:
      statusDisplay = 'Renewing'
      break;
    case PStatus.UPCOMING:
      color = 'blue';
      statusDisplay = 'Upcoming'
      break;
    case PStatus.EXPIRING:
      color = 'red';
      statusDisplay = 'Expiring'
      break;
    case PStatus.QUOTE:
      color = 'green';
      statusDisplay = 'Quote'
      break;
  }

  return (
    <div className={'badge-container ' + color}>{statusDisplay}</div>
  )
}
